import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '@config/app.config';
import { AmlLimitsRepository } from '@core/repositories/aml-limits.repository';
import { AmlLimit } from '@shared/interfaces/aml-limit';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiAmlLimitsRepository implements AmlLimitsRepository {
  constructor(public appConfig: AppConfig, public http: HttpClient) {}

  getItems(): Observable<any> {
    return this.http.get(this.appConfig.SERVICES.limits.findall.url);
  }

  add(limit: AmlLimit): Observable<any> {
    const data = {
      data: {
        attributes: {
          annualCount: limit.annualCount,
          annualValue: limit.annualValue,
          monthlyCount: limit.monthlyCount,
          monthlyValue: limit.monthlyValue,
          segmentId: limit.idSegment
        },
        type: 'AmlControl'
      }
    };

    return this.http.post(this.appConfig.SERVICES.limits.add.url, data);
  }

  edit(limit: AmlLimit): Observable<any> {
    const data = {
      data: {
        attributes: {
          annualCount: limit.annualCount,
          annualValue: limit.annualValue,
          monthlyCount: limit.monthlyCount,
          monthlyValue: limit.monthlyValue,
          segmentId: limit.idSegment
        },
        id: limit.id,
        type: 'AmlControl'
      }
    };
    return this.http.put(this.appConfig.SERVICES.limits.update.url, data);
  }

  delete(item: any): Observable<any> {
    return this.http.delete(
      this.appConfig.SERVICES.limits.delete.url + '/' + item
    );
  }

  segmentWithoutAmlLimits(): Observable<any> {
    return this.http.get(
      this.appConfig.SERVICES.segments.findwithoutamllimit.url
    );
  }
}
